const isLocalhost = window.location.hostname === 'localhost';

export const msalConfig = {
  auth: {
    clientId: "195da0b0-137f-4752-acb2-097b7b3dcdd4",
    authority: "https://login.microsoftonline.com/e41a57ec-10da-4c55-b298-6cedbf20d113",
    redirectUri: isLocalhost ? "http://localhost:3000/" : "https://dev.chassisbot-dev.dcli.com/",
    postLogoutRedirectUri: isLocalhost ? "http://localhost:3000/" : "https://dev.chassisbot-dev.dcli.com/"
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "User.Read"],
  extraQueryParameters: {
    ui_locales: "en-US", // Ensure English locale
    theme: "white" // Set theme to white
  }
};